import type { PostHog } from "posthog-js";
import type { PropsWithChildren } from "react";
import { AnalyticsContext } from "../core/AnalyticsContext";
import type { BaseEvent } from "../core/BaseEvent";
import { ConsoleAnalytics } from "./ConsoleAnalytics";
import { PosthogAnalytics } from "./PosthogAnalytics";

interface Options {
  posthog: PostHog | null;
  application: string;
  applicationVersion: string;
  userType: string;
}

export function createPosthogAnalyticsProvider<
  TEvent extends BaseEvent<object>,
>({ posthog, application, applicationVersion, userType }: Options) {
  const analytics = posthog
    ? new PosthogAnalytics<TEvent>(posthog, { userType })
    : new ConsoleAnalytics<TEvent>();

  analytics.register({
    application,
    applicationVersion,
  });

  return function PosthogAnalyticsProvider({ children }: PropsWithChildren) {
    return (
      <AnalyticsContext.Provider value={analytics}>
        {children}
      </AnalyticsContext.Provider>
    );
  };
}
